export default __webpack_public_path__ + "KaTeX_Size1-Regular.bbd9552cef932199b58e31fb907f8b18.ttf";